export default () => ({
  sidebarMenu: [],
  currentContextType: '',
})
